import i18n from 'i18next';

export const SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY = 'debug_space_config';

const BACKEND_URL: string = window.localStorage.getItem(
  SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY
)
  ? JSON.parse(window.localStorage.getItem(SPACE_DOMAIN_CONFIGURATION_LOCAL_STORAGE_KEY)!)
    .api
  : import.meta.env.VITE_API_URL;

export const APP_URL = import.meta.env.VITE_APP_URL;

let FALLBACK_PRIVACY_PDF_URL = '';

// @deprected whatever you do, do it in `useLegalPdfUrl` hook
i18n.on('initialized', function (options) {
  if (i18n.language === 'fr') {
    FALLBACK_PRIVACY_PDF_URL = BACKEND_URL
      ? BACKEND_URL.replace(/(v1\/)$/, 'Politique-de-confidentialite-et-dutilisation.pdf')
      : '';
  } else if (i18n.language === 'it') {
    FALLBACK_PRIVACY_PDF_URL = BACKEND_URL
      ? BACKEND_URL.replace(/(v1\/)$/, 'Protezione-dei-dati-e-condizioni-di-utilizzo.pdf')
      : '';
  } else {
    FALLBACK_PRIVACY_PDF_URL = BACKEND_URL
      ? BACKEND_URL.replace(/(v1\/)$/, 'Datenschutz_und_Nutzungsbestimmungen.pdf')
      : '';
  }
});

export const FALLBACK_LANGUAGE = 'de';

const USER_CONTEXTS = {
  admin: 'admin',
  participant: 'participant',
  panel: 'panel',
};

export { BACKEND_URL, USER_CONTEXTS, FALLBACK_PRIVACY_PDF_URL };

export const getStatusTypes = () => ({
  done: {
    value: 'done',
    color: '#40A682',
    text: i18n.t<string>('common.finished'),
  },
  inwork: {
    value: 'inwork',
    color: '#EA9328',
    text: i18n.t<string>('common.in-progress'),
  },
  open: {
    value: 'open',
    color: '#a00c09',
    text: i18n.t<string>('common.to-decide'),
  },
});

export const REACTION_FIELD_TYPES = {
  text: { key: 'text', name: 'Text' },
  textarea: { key: 'textarea', name: 'Textarea' },
  dropdown: { key: 'dropdown', name: 'Dropdown' },
};

export const SIZE_PER_PAGE_LIST_FOR_TABLES = [
  { text: '10', value: 10 },
  { text: '15', value: 15 },
  { text: '25', value: 25 },
  { text: '30', value: 30 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '500', value: 500 },
  { text: '1000', value: 1000 },
];

export const COMMENTABLE_ITEM_TYPES = {
  ideaBoardEntry: 'App\\Models\\IdeaBoardEntry\\IdeaBoardEntry',
  comment: 'App\\Models\\Comment\\Comment',
};

export const SENTRY_DO_NOT_REPORT_ERRORS = [403, 422, 409, 400];

export const SALUTATIONS = {
  madam: 'Frau',
  sir: 'Herr',
  'not-specified': 'Keine Angabe',
};

export const INTERNAL_ERROR_CODES = {
  OK_CODE: 0,
  INVALID_EMAIL_VERIFICATION_LINK_CODE: 1,
  TWO_F_A_PHONE_NUMBER_NOT_VERIFIED: 2,
  TWO_F_A_LOGIN_REQUIRED: 3,
  EMAIL_NOT_VERIFIED: 4,
  INVALID_CREDENTIALS: 5,
  USER_IS_LOGGED_IN: 6,
  LOGIN_METHOD_NOT_ALLOWED: 7,
  SSO_LOGIN_FAILED: 8,
  LOGIN_WITH_AZURE_NOT_ALLOWED: 9,
  PASSWORD_RESET_NOT_ALLOWED_WITH_SSO: 10,
  PASSWORD_LOGIN_NOT_ALLOWED_WITH_SSO: 11,

  // No info about the mail address is taken and directly show SSO providers list with the error that has been sent by backend in the toast message
  PASSWORD_LOGIN_NOT_ALLOWED: 12,
  // Show info that the mail address is taken and when user clicks the next button then show him/her the SSO providers list and the toast message that has been sent by backend
  EMAIL_ALREADY_TAKEN_PASSWORD_LOGIN_NOT_ALLOWED: 13,
  // the same flow that we have now
  EMAIL_ALREADY_TAKEN: 14,
  LOGIN_WITH_EZUG_NOT_ALLOWED: 15,
};

export const SSO_LOGIN_METHODS_ERROR_CODES = {
  [INTERNAL_ERROR_CODES.LOGIN_WITH_AZURE_NOT_ALLOWED]: 'Microsoft',
  [INTERNAL_ERROR_CODES.LOGIN_WITH_EZUG_NOT_ALLOWED]: 'eZug',
};

export const SSO_LOGIN_METHODS = {
  [INTERNAL_ERROR_CODES.LOGIN_WITH_AZURE_NOT_ALLOWED]: 'Microsoft',
  [INTERNAL_ERROR_CODES.LOGIN_WITH_EZUG_NOT_ALLOWED]: 'eZug',
};

export const MONTHS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const GIS_INSTRUCTION_PORTAL_URL =
  'https://portal.e-mitwirkung.ch/portal/de/kb/articles/gis-karten-einbinden';

export const THEME_BOARD_SETTINGS = {
  defaultPerPage: 9,
  perPageOptions: [9, 12, 15, 21],
};

export enum DateFormatsEnum {
  DateOnly = 'dd.MM.yyyy',
  Date = 'dd.MM.yyyy',
  DateTime = 'dd.MM.yyyy, HH:mm',
  DateTimeHuman = 'do MMMM yyyy, HH:mm',
  TimeOnly = 'HH:mm',
}